export const accountTypeOptions = [
  { value: '', label: '' },
  { value: 'CC', label: 'Conta Corrente' },
  { value: 'CP', label: 'Conta Poupança' }
]
